import { formatCurrency } from "../../modules/formatCurrency";
import { useTranslation } from "react-i18next";

export const RoomDetails = (props) => {
  const { t } = useTranslation();
  const {
    bookingSidebar,
    branding,
    displayExtraBedPrice,
    currency,
    convertAmount,
  } = props;
  const customParagraphStyle = {
    color: branding.paragraphColor,
    fontFamily: branding.paragraphFont,
  };

  return bookingSidebar
    .filter((item) => item.type !== "addonservice") // Filter out addon services for room rendering
    .map((item, index) => (
      <li className="bs list-group-item d-flex align-items-start" key={index}>
        <div>
          {item.roomName && item.ratePlanName && (
            <>
              <div className="justify-content-between">
                <h1 style={{ fontSize: "2.5rem", color: "#433d80" }}>
                  <strong>{item.roomName}</strong>
                </h1>
                {item.imageurls && item.imageurls[0] && (
                  <img
                    src={item.imageurls[0]}
                    alt={item.roomName}
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      borderRadius: "5px",
                    }}
                  />
                )}
              </div>
              <p>
                <strong>{t("booking.detail.rate_plan")}: </strong>
                <span style={customParagraphStyle}> {item.ratePlanName}</span>
              </p>
              <p>
                <strong>{t("booking.detail.meal_plan")}: </strong>
                <span style={customParagraphStyle}>
                  {" "}
                  {item.mealPlan || "None"}
                </span>
              </p>
              <p>
                <strong>{t("booking.detail.number_of_rooms")}: </strong>
                <span style={customParagraphStyle}> {item.selectedRooms}</span>
              </p>
              <p>
                <strong>{t("booking.detail.adults")}: </strong>
                <span style={customParagraphStyle}>
                  {item.selectedAdults
                    ? Object.values(item.selectedAdults).reduce(
                        (a, b) => a + b,
                        0
                      )
                    : 0}
                </span>
              </p>
              <p>
                <strong>{t("booking.detail.children")}: </strong>
                <span style={customParagraphStyle}>
                  {item.selectedChildren
                    ? Object.values(item.selectedChildren).reduce(
                        (a, b) => a + b,
                        0
                      )
                    : 0}
                </span>
              </p>
              <p>
                <strong>{t("booking.detail.total_rate")}: </strong>
                <span style={customParagraphStyle}>
                  {formatCurrency(
                    item.totalRate * item.selectedRooms,
                    currency,
                    convertAmount
                  )}{" "}
                  {currency}
                </span>
              </p>
              {item.extraBed &&
                Object.values(item.extraBed).some(
                  (isExtraBed) => isExtraBed
                ) && (
                  <p>
                    <strong>{t("booking.detail.extra_bed_price")}: </strong>
                    <span style={customParagraphStyle}>
                      {displayExtraBedPrice}
                    </span>
                  </p>
                )}
              {item.cancellationPolicy && (
                <p>
                  <strong>{t("booking.detail.cancellation_policy")}: </strong>
                  <span style={customParagraphStyle}>
                    {" "}
                    {item.cancellationPolicy}
                  </span>
                </p>
              )}
            </>
          )}
        </div>
      </li>
    ));
};
